/**
 * Media service for interacting with media-related API endpoints.
 *
 * Uses the pre-configured api instance which automatically handles
 * authentication via interceptor.
 */
import api from '../utils/api'

export const addToQueue = async (mediaType, id, cloudId = null) => {
  return await api.post('queue/add/', {
    media_type: mediaType,
    id: id,
    cloud_id: cloudId,
  })
}

export const moveToCollection = async (queueItemId) => {
  return await api.post(`queue/move-to-collection/${queueItemId}/`)
}

export const removeFromQueue = async (queueItemId) => {
  return await api.delete(`queue/remove/${queueItemId}/`)
}

export const checkMediaStatus = async (mediaType, id, cloudId = null) => {
  try {
    console.log(
      `[mediaService] Checking status for ${mediaType} with ID ${id}${cloudId ? `, cloud ID: ${cloudId}` : ''}`
    )
    const params = cloudId ? { cloud_id: cloudId } : {}
    const url = `media-status/${mediaType}/${id}/`
    console.log(`[mediaService] Making request to: ${url}`, { params })
    const response = await api.get(url, { params })
    console.log(`[mediaService] Received response:`, response.data)
    return response.data
  } catch (error) {
    console.error('Error checking media status:', error)
    throw error
  }
}

export const checkTrackStatus = async (id, cloudId = null) => {
  return checkMediaStatus('song', id, cloudId)
}

// Cloud-specific helper functions

export const addToCollectionByCloud = async (mediaType, cloudId) => {
  return await api.post('add-to-collection/', {
    media_type: mediaType,
    cloud_id: cloudId,
  })
}

export const addToQueueByCloud = async (mediaType, cloudId) => {
  return await api.post('queue/add/', {
    media_type: mediaType,
    cloud_id: cloudId,
  })
}

export const removeFromCollectionByCloud = async (mediaType, cloudId) => {
  return await api.delete(`user-media/${mediaType}/${cloudId}/`, {
    params: { cloud_id: cloudId },
  })
}

export const getMediaServiceLinks = async (mediaType, cloudId) => {
  try {
    const response = await api.get(`media-service-links/${mediaType}/${cloudId}/`)
    return response.data
  } catch (error) {
    console.error('Error fetching media service links:', error)
    throw error
  }
}

export const getMediaByCloud = async (mediaType, cloudId) => {
  try {
    const response = await api.get(`media/${mediaType}/${cloudId}/`, {
      params: { cloud_id: cloudId },
    })
    return response.data
  } catch (error) {
    console.error('Error fetching media by cloud:', error)
    throw error
  }
}
